import {
    NewPlanStages,
    policyDetailsInitState,
} from 'components/newPlan/constants';
import { createContext } from 'react';
import { Partners } from 'utils/constants';

interface IMposContext {
    cookie: string;
    partnerId: Partners | string;
    permissions: {
        group: string;
        partner_id: string;
        partner_logo: string;
        role: string;
        permission_list: string[];
        purchase_journey: string;
        lob?: string;
    };
    userDetails: {
        user_id: string;
        address: string;
        email: string;
        name: string;
        partner_id: string;
        phone: string;
        pincode: string;
    };
    metaData: {
        promoter_id_visibility: boolean;
    };
    activeStage: string;
    planDetails: any;
    legalDetailsUploadedStatus: boolean | null;
    loggedUserRole: string;
    gstDetailsValid: boolean;
    gstDetailsSubmitAction: boolean;
    setPlanDetails: any;
    setActiveStage: any;
    permissionsMap: { [permission: string]: boolean };
    dealerType: string;
    showHamburger: boolean;
    setPermissions: any;
    setUserDetails: any;
    setPartnerId: any;
    setShowHamburger: any;
    setSnackbar: any;
    setLoggedUserRole: any;
    setGstDetailsValid: any;
    setGstDetailsSubmitAction: any;
    setLegalDetailsUploadedStatus: any;
    setMetaData: any;
    setPermissionsMap: any;
}

export const MPosContext = createContext<IMposContext>({
    cookie: '',
    partnerId: '',
    permissions: {
        group: '',
        partner_id: '',
        partner_logo: '',
        permission_list: [],
        role: '',
        purchase_journey: 'v0',
    },
    userDetails: {
        user_id: '',
        address: '',
        email: '',
        name: '',
        partner_id: '',
        phone: '',
        pincode: '',
    },
    metaData: {
        promoter_id_visibility: false,
    },
    dealerType: '',
    showHamburger: true,
    permissionsMap: {},
    activeStage: NewPlanStages.MODEL,
    planDetails: policyDetailsInitState,
    legalDetailsUploadedStatus: null,
    loggedUserRole: '',
    gstDetailsValid: true,
    gstDetailsSubmitAction: true,
    setPlanDetails: () => {},
    setActiveStage: () => {},
    setPermissions: () => {},
    setUserDetails: () => {},
    setPartnerId: () => {},
    setShowHamburger: () => {},
    setSnackbar: () => {},
    setLoggedUserRole: () => {},
    setLegalDetailsUploadedStatus: () => {},
    setGstDetailsValid: () => {},
    setMetaData: () => {},
    setPermissionsMap: () => {},
    setGstDetailsSubmitAction: () => {},
});
